/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { getPersona } from 'blb-persona/index';
import { MeContext } from 'blb-contexts/Me';

export namespace Sidebar {
  export interface Props {}
}

export const Sidebar: React.FC<Sidebar.Props> = ({}) => {
  const me = React.useContext(MeContext)!;
  const persona = getPersona(me.principalType);
  return persona.renderProfileSidebar();
};
